import React from 'react';

export default {
  scheduleDeliveryInstructionsContentForCarrier: (
    <>
      {
        '\n  お届け日時の変更は1回のみ可能です。お届け日時の再変更をご希望の場合は、佐川急便の担当営業所までご連絡ください。担当営業所は '
      }
      <a
        href="https://www2.sagawa-exp.co.jp/branch_search/"
        target="_blank"
        rel="noreferrer"
      >
        https://www2.sagawa-exp.co.jp/branch_search/
      </a>
      {' から検索することができます。'}
    </>
  ),
};
